// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Package/index.css
// module id = 2282
// module chunks = 0